var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxcheckedreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "#fff",
    stroke: "#D0D5DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98 11.635a1.3 1.3 0 01-1.807 0l-2.799-2.73a1.224 1.224 0 010-1.762 1.3 1.3 0 011.806 0l1.668 1.626a.33.33 0 00.456 0l4.515-4.404a1.3 1.3 0 011.807 0c.24.233.374.55.374.88 0 .331-.134.648-.374.882l-5.647 5.508z",
    fill: "#333"
  })));
}
export default SvgCheckboxcheckedreact;